// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
            ? global
            : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"erHbO":[function(require,module,exports,__globalThis) {
require("8067620a55dc4153").register(require("c52e655a4d3b103a").getBundleURL('kkkhJ'), JSON.parse("[\"kkkhJ\",\"index.49ff2701.js\",\"5vcKv\",\"atlassian-light.0a48807e.js\",\"6o6gJ\",\"atlassian-light-future.c1f64aa4.js\",\"29n0N\",\"atlassian-light-increased-contrast.3c82a93c.js\",\"7MiB3\",\"atlassian-dark.1cae3254.js\",\"9kzPW\",\"atlassian-dark-future.67ead8c2.js\",\"7BlKt\",\"atlassian-dark-increased-contrast.974349d5.js\",\"auqcp\",\"atlassian-spacing.8f980524.js\",\"1wUNB\",\"atlassian-typography.fa4b4fa5.js\",\"l51TO\",\"atlassian-shape.956e3a3d.js\",\"bZZmZ\",\"atlassian-motion.b7cef978.js\",\"kctVh\",\"custom-theme.45874d83.js\",\"MPOnK\",\"cs.484654ac.js\",\"gVDfT\",\"da.04106828.js\",\"dIrro\",\"de.761221bf.js\",\"6KHZa\",\"en_GB.100e4a49.js\",\"aB9xC\",\"en_ZZ.73de8207.js\",\"byFnW\",\"es.ddccfb79.js\",\"aM5FL\",\"fi.9b8ae878.js\",\"lPVP4\",\"fr.79a5c155.js\",\"4E3Up\",\"hu.be67b4e5.js\",\"31T3F\",\"it.3eae4360.js\",\"kU8UN\",\"ja.a6615a46.js\",\"jUKrZ\",\"ko.593f43bb.js\",\"2P4VV\",\"nb.aa57dccd.js\",\"fQjeh\",\"nl.fad7b748.js\",\"5ytOl\",\"pl.337346e7.js\",\"2kbmC\",\"pt_BR.368a29ec.js\",\"aXMdp\",\"ru.e2045328.js\",\"cOHLf\",\"sl.fadc0bb3.js\",\"dYz4o\",\"sr_RS.46df56f4.js\",\"kM9hD\",\"sr_YR.058b7ac6.js\",\"TIhIi\",\"sv.c938aae6.js\",\"6Nr8y\",\"th.5a7290b4.js\",\"iNazb\",\"tr.2583a19e.js\",\"koG8I\",\"uk.9549a404.js\",\"4RuWj\",\"vi.19d10490.js\",\"lEIXr\",\"zh_TW.e919c010.js\",\"tfhRV\",\"zh.d5a16d67.js\",\"7H8jk\",\"InactivePage.d1a18aad.js\",\"6oTyQ\",\"HistoryPage.68b696b0.js\",\"lsELk\",\"HistoryPage.632ed83d.js\",\"3Uw2a\",\"HistoryPage.742d954c.js\",\"gct5i\",\"IncidentDetailPage.b90b8f97.js\",\"274zX\",\"LiveStatusPage.1f9d3218.js\"]"));

},{"8067620a55dc4153":"l4T2r","c52e655a4d3b103a":"cZKtR"}],"l4T2r":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"cZKtR":[function(require,module,exports,__globalThis) {
"use strict";
const stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function getBundleURLCached(id, inputError) {
    let value = bundleURL[id];
    if (!value) {
        value = getBundleURL(inputError);
        bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function getOrigin(url) {
    return new URL(url).origin;
}
// TODO: convert this file to ESM once HMR issues are resolved
exports.getOrigin = getOrigin;
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;

},{}]},["erHbO"], null, "parcelRequire213a")

//# sourceMappingURL=index.runtime.51d9782a.js.map
